<template>
	<div class="cmbc_confirm">
		<naviBack type='list1' title="订单确认页" background="#FFFFFF" />
		<div v-if="order_confirm" class="width_100 cmbc_list">
			<div class="cmbc_list_block width_100 bg_FFFFFF border_radius_16">
				<div class="width_100 display_between_start font_size_28">
					<div class="cmbc_list_block_left color_666666">订单编号</div>
					<div class="cmbc_list_block_right color_333333">{{order_confirm.orderNo}}</div>
				</div>
				<div class="width_100 display_between_start font_size_28">
					<div class="cmbc_list_block_left color_666666">服务名称</div>
					<div class="cmbc_list_block_right color_333333">{{order_confirm.serviceName}}</div>
				</div>
				<div class="width_100 display_between_start font_size_28">
					<div class="cmbc_list_block_left color_666666">兑换时间</div>
					<div class="cmbc_list_block_right color_333333">{{order_confirm.createTime}}</div>
				</div>
				<div class="width_100 display_between_start font_size_28">
					<div class="cmbc_list_block_left color_666666">兑换消耗</div>
					<div class="cmbc_list_block_right color_333333">{{order_confirm.orderAmount}}积点</div>
				</div>
				<div class="cmbc_list_block_line"><div></div></div>
				<div class="width_100 display_between_start font_size_28">
					<div class="cmbc_list_block_left color_666666">预约人</div>
					<div class="cmbc_list_block_right color_333333">{{order_confirm.bookName}}　{{order_confirm.bookMobile}}</div>
				</div>
				<div class="width_100 display_between_start font_size_28">
					<div class="cmbc_list_block_left color_666666">预约时间</div>
					<div class="cmbc_list_block_right color_333333">{{order_confirm.bookDate}}　{{order_confirm.bookTime}}</div>
				</div>
				<!-- <div class="width_100 display_between_start font_size_28">
					<div class="cmbc_list_block_left color_666666">预约场地</div>
					<div class="cmbc_list_block_right color_333333">1号场地 07:00-08:00<br />3号场地 14:00-15:00</div>
				</div> -->
				<div class="width_100 display_between_start font_size_28">
					<div class="cmbc_list_block_left color_666666">预约数量</div>
					<div class="cmbc_list_block_right color_333333">{{order_confirm.num}}</div>
				</div>
				<div class="width_100 display_between_start font_size_28">
					<div class="cmbc_list_block_left color_666666">场馆名称</div>
					<div class="cmbc_list_block_right color_333333">{{order_confirm.venueName}}</div>
				</div>
				<div v-if="goods_info" class="width_100 display_between_start font_size_28">
					<div class="cmbc_list_block_left color_666666">场馆地址</div>
					<div class="cmbc_list_block_right color_333333">{{goods_info.venueInfo.address}}</div>
				</div>
			</div>
		</div>
		<div v-if="order_confirm && order_confirm.payUrl" class="cmbc_list_bottom width_100 bg_FFFFFF">
			<div @click="nextPage()" class="width_100 color_ffffff display_center_center font_size_32">去支付</div>
		</div>
	</div>
</template>

<script>
	import {
		datePrintStr,isPhone
	} from "../lib/utils"
	import naviBack from '../components/navi_back.vue';
	export default {
		components: {
			naviBack,
		},
		name: "",
		data() {
			return {
				order_confirm:null,
				goods_info:null,
			};
		},
		mounted() {
			if(this.order_confirm){
				this.$router.go(-1)
			}
			var order_confirm=JSON.parse(sessionStorage.getItem('order_confirm'))
			order_confirm.date_obj=datePrintStr(order_confirm.date)
			// console.log('order_confirm',order_confirm);
			this.order_confirm=order_confirm
			this.goods_info=JSON.parse(sessionStorage.getItem('goods_info'))
		},
		methods: {
			nextPage(){
				window.location.href=this.order_confirm.payUrl
			}
		},
	};
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750 * 100vw;
	.cmbc_confirm{
		min-height: 100vh;
		position: relative;
	}
	.cmbc_list{
		padding: 20*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 150*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 150*@vm_base);
		.cmbc_list_block{
			padding: 15*@vm_base 30*@vm_base;
			.cmbc_list_block_left{
				width: 30%;
				line-height: calc(58 / 28);
			}
			.cmbc_list_block_right{
				width: 70%;
				line-height: calc(58 / 28);
			}
			.cmbc_list_block_line{
				padding: 15*@vm_base 0;
				div{
					width: 100%;
					border-top: 1*@vm_base solid #D9D9D9;
				}
			}
		}
	}
	.cmbc_list_bottom{
		position: fixed;
		bottom: 0;
		left: 0;
		padding: 25*@vm_base 75*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 25*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 25*@vm_base);
		box-shadow: -4*@vm_base -4*@vm_base 6*@vm_base rgba(243, 207, 166, 0.5);
		border-radius: 16*@vm_base 16*@vm_base 0 0;
		
		div{
			height: 80*@vm_base;
			background: linear-gradient( 233deg, #FB8027 0%, #FFA663 100%);
			border-radius: 40*@vm_base;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/order_comfirm.vue